import React from "react"
import { OpenModalButton } from "../../common/components/openModalButton"
import ModelloClimaForm from "./ModelloClimaForm";
import Actions from "../ModelliClimaActions";
import { ModelloClimaDto, ModelloClimaDataDto } from "../../generated";
import { ModelliClimaStore } from "../ModelliClimaStore";
import { Loading } from "../../common/components/loading";

interface Props { id?: number; onSelect: (idCaldaia: ModelloClimaDto | null) => void }

const ModalContent = (props: { id?: number, onClose: (caldaia: ModelloClimaDto | null) => void }) => {

    const { onClose } = props;

    const modelloClima = props.id ? ModelliClimaStore.use(props.id) : new ModelloClimaDto();
    if (!modelloClima)
        return <Loading />

    const save = async (caldaia: ModelloClimaDataDto) => {
        if (props.id) {
            const result = await Actions.update(props.id, caldaia);
            onClose(result);
        }
        else {
            const result = await Actions.add(caldaia);
            onClose(result);
        }
    }

    return (
        <ModelloClimaForm
            modelloClima={modelloClima}
            onSubmit={save}
            onCancel={() => onClose(null)}
        />
    );
}

export const ModelloClimaToolbarButton = (props: Props) => {
    const modal = React.useRef<OpenModalButton>(null);
    return <div className="row">
        <div className="col-6">
            <OpenModalButton
                ref={modal}
                forceReload
                className="btn btn-outline-secondary w-100"
                modalContent={<ModalContent
                    onClose={id => {
                        modal.current!.close();
                        if (id != null)
                            props.onSelect(id);
                    }}
                />}
            >
                <i className="fas fa-plus" />  Modello
            </OpenModalButton>
        </div>
        {props.id != null &&
            <div className="col-6">
                <OpenModalButton
                    ref={modal}
                    forceReload
                    className="btn btn-outline-secondary w-100"
                    modalContent={<ModalContent
                        id={props.id}
                        onClose={id => {
                            modal.current!.close();
                            if (id != null)
                                props.onSelect(id);
                        }}
                    />}
                >
                    <i className="fas fa-edit" /> Modifica
                </OpenModalButton>
            </div>
        }
    </div>
}
